import styled from 'styled-components';
import { Card, Button, Tabs, Empty } from 'antd';

export const TournamentCard = styled(Card)`
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
  background: ${props => props.theme.background || '#ffffff'};
  border: 2px solid ${props => props.theme.border || '#e8e8e8'};
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 2px 4px rgba(0, 0, 0, 0.04);

  &:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: 
      0 12px 32px rgba(24, 144, 255, 0.2),
      0 6px 16px rgba(24, 144, 255, 0.15);
    border-color: ${props => props.theme.primary || '#1890ff'};
  }

  /* Стили для темной темы */
  [data-theme='dark'] & {
    background: ${props => props.theme.secondaryBackground || '#141414'};
    border-color: ${props => props.theme.border || '#303030'};
    box-shadow: 
      0 1px 3px rgba(0, 0, 0, 0.3),
      0 2px 6px rgba(0, 0, 0, 0.2);

    &:hover {
      border-color: ${props => props.theme.primary || '#1890ff'};
      box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.4),
        0 8px 24px rgba(0, 0, 0, 0.3);
    }
  }

  .ant-card-body {
    padding: 20px;
  }

  .tournament-title {
    margin-bottom: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 48px;
    height: auto;
  }

  .tournament-info {
    color: ${props => props.theme.textLight || '#666'};
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
  }

  .tournament-status {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tournament-footer {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid ${props => props.theme.border || '#e8e8e8'};
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;

export const CreateButton = styled(Button)`
  height: 40px;
  padding: 0 24px;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledEmpty = styled(Empty)`
  margin: 48px 0;

  .ant-empty-image {
    height: 160px;
  }

  .ant-empty-description {
    font-size: 16px;
    color: #666;
  }
`;

export const StyledTabs = styled(Tabs)`
  margin-bottom: 24px;
  
  .ant-tabs-nav {
    margin-bottom: 0;
  }
  
  .ant-tabs-tab {
    font-size: 16px;
    font-weight: 500;
    padding: 12px 24px;
  }
  
  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      color: #1890ff;
      font-weight: 600;
    }
  }
  
  .ant-tabs-ink-bar {
    background: #1890ff;
    height: 2px;
  }
`;

